'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getItem = exports.removeItem = exports.setItem = exports.hasLocalStorage = exports.hasSessionStorage = void 0;
/**
 * Checks if setting session storage throws an error
 * @returns boolean
 */
function hasSessionStorage() {
    try {
        sessionStorage.setItem('x-session-test', 'available');
        sessionStorage.removeItem('x-session-test');
        return true;
    }
    catch (_a) {
        return false;
    }
}
exports.hasSessionStorage = hasSessionStorage;
/**
 * Checks if setting local storage throws an error
 * @returns boolean
 */
function hasLocalStorage() {
    try {
        localStorage.setItem('x-local-test', 'available');
        localStorage.removeItem('x-local-test');
        return true;
    }
    catch (_a) {
        return false;
    }
}
exports.hasLocalStorage = hasLocalStorage;
/**
 * Stringifies data and puts it in a local storage.
 * @param key
 * @param data
 */
function setItem(key, data) {
    try {
        window.localStorage.setItem(key, JSON.stringify(data));
    }
    catch (e) {
        console.error('localStorage', e);
    }
}
exports.setItem = setItem;
/**
 * Remove an item from a local storage with a key.
 * @param key
 */
function removeItem(key) {
    try {
        window.localStorage.removeItem(key);
    }
    catch (e) {
        console.error('localStorage', e);
    }
}
exports.removeItem = removeItem;
/**
 * Retrieves a JSON value from a local storage.
 * @param key
 */
function getItem(key) {
    var data = window.localStorage.getItem(key);
    return data === null ? data : JSON.parse(data);
}
exports.getItem = getItem;
